// extracted by mini-css-extract-plugin
export default {"file":"style_file__IOC4x","button":"style_button__sxtOA","totle":"style_totle__FvE2t","icon":"style_icon__ii2Pf"};